import React, { ReactElement } from 'react';
import { ActivityIndicator } from '../../feedback/activityindicator';

export interface MaskProps {
   show: boolean;
}

export const Mask = (props: MaskProps): ReactElement | null => {
   if (props.show) {
      return (
         <div className="unifocus-mask">
            <ActivityIndicator/>
         </div>
      );
   }

   return null;
};
